import { useEffect, useState } from "react";

const items = [
    { id: "section-production", label: "Production" },
    { id: "section-economics", label: "Economics" },
    { id: "section-feeding", label: "Feeding" },
    { id: "section-feed-cost", label: "Feed Cost" },
    { id: "section-labour", label: "Labour" },
    { id: "section-housing", label: "Housing" },
    { id: "section-health", label: "Health" },
    { id: "section-reproduction", label: "Reproduction" },
    { id: "section-environment", label: "Environment" },
    { id: "section-business", label: "Business" },
    { id: "section-ratings", label: "Ratings" },
    { id: "section-recommendation", label: "Verdict" },
];

export default function BreedTOC() {
    const [active, setActive] = useState("");
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setVisible(window.scrollY > window.innerHeight * 0.8);
            let current = "";
            for (const it of items) {
                const el = document.querySelector(`[data-testid="${it.id}"]`);
                if (el && el.getBoundingClientRect().top < 200) {
                    current = it.id;
                }
            }
            setActive(current);
        };
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const jumpTo = (id) => {
        const el = document.querySelector(`[data-testid="${id}"]`);
        if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 80, behavior: "smooth" });
    };

    return (
        <aside
            data-testid="breed-toc"
            className={`hidden xl:block fixed left-6 top-1/2 -translate-y-1/2 z-40 transition-opacity duration-700 ${visible ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        >
            <ul className="space-y-2.5">
                {items.map((it) => {
                    const isActive = active === it.id;
                    return (
                        <li key={it.id}>
                            <button
                                onClick={() => jumpTo(it.id)}
                                data-testid={`toc-${it.id}`}
                                className="group flex items-center gap-3 text-[11px] uppercase tracking-widest"
                                aria-current={isActive}
                            >
                                <span className={`h-px transition-[width,background] duration-500 ease-editorial ${isActive ? "w-8 bg-gold" : "w-4 bg-ink/30 group-hover:w-6 group-hover:bg-ink/60"}`} />
                                <span className={`transition-colors ${isActive ? "text-forest font-medium" : "text-ink/40 group-hover:text-ink/70"}`}>
                                    {it.label}
                                </span>
                            </button>
                        </li>
                    );
                })}
            </ul>
        </aside>
    );
}
